<template>

    <main :class="{'open': !hidden}" class="crud-main">
        <slot></slot>
    </main>

</template>

<style lang="scss">
    main.crud-main {
        background-color: #FFF;
        border-radius: $standardBorderRadius;
        padding: 1em;

        table {
            border-collapse: collapse;
            margin: 1.5em 0;
            table-layout: fixed;
            text-align: left;
            width: 100%;
        }

        thead {
            line-height: 1.2;
            vertical-align: bottom;
        }

        tbody {
            vertical-align: top;
        }

        tr {
            border-bottom: 1px solid #ddd;
        }

        th {
            font-weight: 600;
        }

        th,
        td {
            padding: 0.75em 0.75em 0.75em 0;
        }

        @include grid-column(12);

        @include desktop() {
            @include grid-column(8);
        }

        @include mobile() {
            display: none;
            &.open {
                display: block;
                border-radius: 0;
                width: 100%;
                margin: -1em 0 -1em 0;
                float: none;
            }
        }

        dl {
            @include clearfix();
            dt {
                width: 150px;
                float: left;
                margin-right: 15px;
                clear: both;
            }
            dd {
                float: left;
                img{
                    width: 200px;
                    max-width: 100%;
                    border-radius:$standardBorderRadius;
                }
            }

            dt, dd {
                margin-bottom: 10px;
            }
            @include mobile() {
                dd {
                    width: 100%;
                    clear: both;
                }
            }
        }

        .action-buttons {
            float: right;
            margin-top: -24px;
            a, a.action-button {
                margin-left: 10px;
                float: none;
                clear: none;
                display: inline-block;
                &:first-of-type {
                    margin-left: 0;
                }
            }
        }
    }


</style>

<script>
    export default {
        data() {
            return {
                hidden: true
            }
        },
        watch: {},
        computed: {
            name() {
                return this.$parent.name;
            }
        },
        methods: {},
        mounted() {
            var that = this;

            window.eventBus.$on('crud-show-main-' + this.name, function () {
                that.hidden = false;
            });

            window.eventBus.$on('crud-hide-main-' + this.name, function () {
                that.hidden = true;
            });
        }
    }
</script>
